export default {
      id: "person_operative-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "sprite.svg#person_operative",
      toString: function () {
        return this.url;
      }
    }